module.exports = __webpack_public_path__ + "img/icn_caution.27d9113e.svg";